<template>
  <bean-source-page
    :type="type"
    :form-columns="formColumns"
    :form="form"
    :title="$t('changePassword')"
    :onFetchData="onFetchData"
    :onFormSubmit="onFormSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ChangePassword extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'current_password',
        label: this.$t('currentPassword'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            type: 'password'
          }
        }
      },
      {
        prop: 'password',
        label: this.$t('newPassword'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            type: 'password'
          }
        }
      },
      {
        prop: 'password_confirmation',
        label: this.$t('confirmPassword'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            type: 'password'
          }
        }
      }
    ];
  }

  onFetchData() {
    return {}
  }

  async onFormSubmit({ data }) {
    const body = data;

    await this.$request.put('mine/change_password', body);
    this.$message.success(this.$t('bean.updateSuccess'));
    this.$router.push({ name: 'profile.show' });
  }
}

export const route = [
  {
    path: '/profile/change_password',
    name: 'profile.change_password',
    component: ChangePassword,
    props: {
      type: 'edit'
    }
  }
]
</script>
